import React from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  Spinner,
  Input,
  CardHeader,
} from "reactstrap";
import SimpleBar from "simplebar-react";

const TicketDescription = ({
  ticket,
  formatDate,
  messageText,
  setMessageText,
  handleSend,
  replyTicketLoading,
  chatBottomRef,
}) => {
  const messages = ticket.Messages || [];

  return (
    <React.Fragment>
      <Col xxl={9}>
        <Card className="border-none shadow">
          <CardHeader
            className="bg-transparent border-bottom border-light"
            style={{ padding: "0.846rem 1rem" }}
          >
            <h5 className="card-title mb-0 text-dark">Mesaj Geçmişi</h5>
          </CardHeader>
          <CardBody className="p-4">
            <SimpleBar style={{ maxHeight: "400px" }} className="px-3 mx-n3">
              {messages.length > 0 ? (
                messages.map((msg, index) => {
                  const isSupport = msg.RoleName === "SuperAdmin";

                  const borderClass =
                    index !== messages.length - 1
                      ? "border-bottom border-light"
                      : "";

                  const avatarBg = !isSupport
                    ? "bg-light text-secondary"
                    : "bg-primary text-white";

                  const avatarIcon = !isSupport
                    ? "ri-user-3-line"
                    : "ri-customer-service-2-fill";

                  return (
                    <div
                      key={msg.Id || index}
                      className={`d-flex mb-4 pb-4 ${borderClass}`}
                    >
                      <div className="flex-shrink-0 me-3">
                        <div className="avatar-xs">
                          <span
                            className={`avatar-title rounded-circle shadow-sm ${avatarBg}`}
                          >
                            <i className={avatarIcon}></i>
                          </span>
                        </div>
                      </div>

                      <div className="flex-grow-1">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <div>
                            <h5 className="fs-12 mb-0 fw-medium text-primary">
                              {msg.UserName}
                              {isSupport && (
                                <span className="badge bg-primary-subtle text-primary ms-2 fs-10 border border-primary-subtle">
                                  Destek Ekibi
                                </span>
                              )}
                            </h5>
                          </div>
                          <small className="text-muted fs-11">
                            {formatDate(msg.CreatedAt)}
                          </small>
                        </div>

                        <p
                          className="text-primary mb-0 fs-12"
                          style={{ whiteSpace: "pre-wrap", lineHeight: "1.6" }}
                        >
                          {msg.Message}
                        </p>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="text-center text-muted my-5">
                  <div className="avatar-lg mx-auto mb-3">
                    <div className="avatar-title bg-light rounded-circle text-secondary display-5">
                      <i className="ri-discuss-line"></i>
                    </div>
                  </div>
                  <p className="mt-2">Henüz bir mesajlaşma başlatılmadı.</p>
                </div>
              )}
              <div ref={chatBottomRef} />
            </SimpleBar>

            <div className="mt-4 pt-4 border-top ">
              {ticket.StatusText !== "Closed" ? (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleSend();
                  }}
                >
                  <div className="d-flex align-items-center gap-3">
                    <div className="flex-grow-1">
                      <Input
                        type="textarea"
                        className="bg-white border-light"
                        rows="3"
                        placeholder="Yanıtınızı buraya yazın..."
                        value={messageText}
                        onChange={(e) => setMessageText(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && !e.shiftKey) {
                            e.preventDefault();
                            handleSend();
                          }
                        }}
                        disabled={replyTicketLoading}
                        style={{ resize: "none", borderRadius: "8px" }}
                      />
                    </div>
                    <div className="flex-shrink-0">
                      <Button
                        color="primary"
                        className="btn-icon btn-lg rounded-circle shadow-sm"
                        onClick={handleSend}
                        disabled={replyTicketLoading}
                        title="Gönder"
                        style={{ width: "50px", height: "50px" }}
                      >
                        {replyTicketLoading ? (
                          <Spinner size="sm" />
                        ) : (
                          <i className="ri-send-plane-fill fs-18"></i>
                        )}
                      </Button>
                    </div>
                  </div>
                </form>
              ) : (
                <div className="alert alert-light border text-center text-muted mt-3">
                  <i className="ri-lock-2-line me-1"></i> Bu talep
                  kapatılmıştır.
                </div>
              )}
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default TicketDescription;
